import styled from "styled-components";

export const ProcedureScheduleCardTopContainer = styled.div`
  width: 100%;
  padding-bottom: 4px;

  > div {
    box-sizing: border-box;
    width: 100%;
    height: auto;
    padding: 10px;
  }
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const LeftContainer = styled.div`
  display: grid;
  min-width: 0;
  grid-template-columns: 60px minmax(0, 1fr);
  align-items: start;
  gap: 8px;

  > div:first-child {
    margin: 0;
    padding: 0;
  }

  > div:last-child {
    min-width: 0;
    overflow-wrap: anywhere;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
`;

export const ButtonContainer = styled.div`
  flex-shrink: 0;
`;
